import { ArrayBone } from '@europrocurement/flexy-components';
import { TableBody, TableCell, TableRow } from '@mui/material';
import React from 'react';

export const FlexyDatatableBodyLoading: React.FunctionComponent = function () {
    return (
        <TableBody data-testid="FlexyDatatableBody">
            <TableRow>
                <TableCell
                    data-testid="StatusLoading"
                    colSpan={12}
                    sx={{ height: '45vh' }}
                >
                    <ArrayBone
                        withHeader={false}
                        columns={4}
                        rows={8}
                    />
                </TableCell>
            </TableRow>
        </TableBody>
    );
};
